import { NCFileTypeOption, PartMode } from '@components/common/NCFileType/NCFileWizardNoERP/types';

export { NC_FILE_TYPE_OPTIONS } from '../../constants';

export const WIZARD_STEPS = [
  { step: 1, label: 'Type', title: 'Configure NC File' },
  { step: 2, label: 'Part', title: 'Link to Part' },
  { step: 3, label: 'Time', title: 'Paid Time' },
  { step: 4, label: 'Summary', title: 'Review & Save' },
] as const;

export const TYPE_DESCRIPTIONS: Record<NCFileTypeOption, string> = {
  linked: 'This program produces a part. Production time counts toward output and OEE.',
  change: 'This program runs between parts — e.g. tool change, fixture swap, or pallet rotation. Production time counts as changeover.',
  setup: 'This program prepares the machine — tool measurement, zero-point calibration, or fixture probing. Production time counts as setup.',
  ignore: 'This program has no production relevance — e.g. warm-up cycle, test run, or maintenance routine. Production time is excluded from reporting.',
};

export const isSimpleType = (selectedType: NCFileTypeOption): boolean =>
  selectedType === 'change' || selectedType === 'ignore' || selectedType === 'setup';

export const PART_MODE_OPTIONS: { key: PartMode; label: string }[] = [
  { key: 'existing', label: 'Select Existing' },
  { key: 'new', label: 'Create New' },
];

export const TIME_PLACEHOLDER = '0:00:00';

export const TIME_FORMAT_HINT = 'Formats: 1.5h, 1h30m, 1u30, 90m, 1:30, 90s, 1h + 30m';

export const INITIAL_PART_DATA = {
  partId: null,
  partNumber: '',
  partDrawingNumber: '',
  partDrawingRevision: '',
  partDrawingPosition: '',
  partDescription: '',
};

export const INITIAL_TIME_DATA = {
  paidCycleTime: '',
  paidSetupTime: '',
  activeTime: '',
  changeTime: '',
  isManualSplit: false,
};
